import { useState } from 'react';


export const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const baseUrl = (import.meta.env.VITE_SSO_AUTH_URL as string | undefined) ?? '';

  // Build base URLs with client-id
  const requestUrl = new URL(`${baseUrl}/auth/password-reset/request-password-reset`);
  const resetUrl = new URL(`${baseUrl}/auth/password-reset/reset-password`);

  const requestPasswordReset = async (email: string): Promise<boolean> => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setOtpSent(false);

    try {
      const payload = { email };
      console.log('Requesting password reset:', { url: requestUrl.toString(), payload });

      const res = await fetch(requestUrl.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        },
        credentials: 'include',
        cache: 'no-store',
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const message = data?.message || `HTTP ${res.status}`;
        throw new Error(message);
      }

      setOtpSent(true);
      setSuccess(true);
      return true;
    } catch (err: any) {
      const message = err.message || 'Failed to send OTP. Please try again.';
      setError(message);
      setSuccess(false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (email: string, otp: string, newPassword: string): Promise<boolean> => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const payload = { email, otp, newPassword };
      console.log('Resetting password:', { url: resetUrl.toString(), payload });

      const res = await fetch(resetUrl.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        },
        credentials: 'include',
        cache: 'no-store',
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const message = data?.message || `HTTP ${res.status}`;
        throw new Error(message);
      }

      setSuccess(true);
      return true;
    } catch (err: any) {
      const message = err.message || 'Failed to reset password. Please try again.';
      setError(message);
      setSuccess(false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    requestPasswordReset,
    resetPassword,
    loading,
    error,
    success,
    otpSent,
    setOtpSent,
  };
};